import React from "react";
import localeText from "../../../../../../../locale";
import FormSectionHeader from "../components/FormSectionHeader";
import DigitalFileCard from "../components/DigitalFileCard";
import { COVER_MAX_BYTES, DIGITAL_FILE_MAX_BYTES } from "../constants";

function DigitalFilesSection({ form }) {
  if (form.productType !== 3) return null;

  const cover = form.images?.[0] || null;

  const svgIcon = (
    <svg width="19" height="21" viewBox="0 0 19 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.30003 0.00315002V0H17.8479C18.4275 0 18.9 0.47775 18.9 1.0416V19.9584C18.8997 20.2347 18.7898 20.4997 18.5943 20.695C18.3988 20.8903 18.1337 21 17.8574 21H1.04268C0.904787 20.999 0.768438 20.9709 0.641414 20.9173C0.51439 20.8636 0.399179 20.7855 0.302359 20.6873C0.205539 20.5891 0.129007 20.4728 0.0771327 20.345C0.0252582 20.2173 -0.000942694 20.0805 2.59066e-05 19.9426V6.3L6.30003 0.00315002ZM2.97153 6.3H6.30003V2.9715L2.97153 6.3ZM8.40003 2.1V7.35C8.40003 7.62848 8.2894 7.89555 8.09249 8.09246C7.89558 8.28937 7.6285 8.4 7.35003 8.4H2.10003V18.9H16.8V2.1H8.40003Z"
        fill="var(--theme-secondary)"
      />
    </svg>
  );
  const svgIconImg = (
    <svg width="24" height="21" viewBox="0 0 24 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.95 12.6V15.75H23.1V17.85H19.95V21H17.85V17.85H14.7V15.75H17.85V12.6H19.95ZM19.9584 0C20.5338 0 21 0.46725 21 1.04265V10.8591C20.3255 10.6209 19.6153 10.4994 18.9 10.5V2.1H2.1L2.10105 16.8L11.8576 7.04235C12.0382 6.8612 12.2787 6.75227 12.534 6.73603C12.7892 6.71978 13.0416 6.79735 13.2436 6.95415L13.3413 7.0434L17.0646 10.7709C16.2505 11.019 15.495 11.4294 14.8438 11.9773C14.1926 12.5253 13.659 13.1994 13.2754 13.9591C12.8918 14.7188 12.666 15.5484 12.6116 16.3977C12.5572 17.2471 12.6755 18.0986 12.9591 18.901L1.0416 18.9C0.765254 18.8997 0.500322 18.7897 0.305014 18.5942C0.109706 18.3987 -1.40128e-07 18.1337 0 17.8573V1.04265C0.00192155 0.766897 0.112245 0.502968 0.307139 0.307879C0.502032 0.112789 0.765849 0.00219938 1.0416 0H19.9584ZM6.3 4.2C6.85695 4.2 7.3911 4.42125 7.78492 4.81508C8.17875 5.2089 8.4 5.74305 8.4 6.3C8.4 6.85695 8.17875 7.3911 7.78492 7.78492C7.3911 8.17875 6.85695 8.4 6.3 8.4C5.74305 8.4 5.2089 8.17875 4.81508 7.78492C4.42125 7.3911 4.2 6.85695 4.2 6.3C4.2 5.74305 4.42125 5.2089 4.81508 4.81508C5.2089 4.42125 5.74305 4.2 6.3 4.2V4.2Z"
        fill="var(--theme-secondary)"
      />
    </svg>
  );
  const svgIconFile = (
    <svg width="19" height="21" viewBox="0 0 19 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.85 21H1.05C0.771523 21 0.504451 20.8894 0.307538 20.6925C0.110625 20.4955 0 20.2285 0 19.95V1.05C0 0.771523 0.110625 0.504451 0.307538 0.307538C0.504451 0.110625 0.771523 0 1.05 0H17.85C18.1285 0 18.3956 0.110625 18.5925 0.307538C18.7894 0.504451 18.9 0.771523 18.9 1.05V19.95C18.9 20.2285 18.7894 20.4955 18.5925 20.6925C18.3956 20.8894 18.1285 21 17.85 21ZM16.8 18.9V2.1H2.1V18.9H16.8ZM5.25 5.25H13.65V7.35H5.25V5.25ZM5.25 9.45H13.65V11.55H5.25V9.45ZM5.25 13.65H10.5V15.75H5.25V13.65Z"
        fill="var(--theme-secondary)"
      />
    </svg>
  );
  const svgIconSample = (
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.5 21C4.70085 21 0 16.2991 0 10.5C0 4.70085 4.70085 0 10.5 0C16.2991 0 21 4.70085 21 10.5C21 16.2991 16.2991 21 10.5 21ZM10.5 18.9C12.7278 18.9 14.8644 18.015 16.4397 16.4397C18.015 14.8644 18.9 12.7278 18.9 10.5C18.9 8.27218 18.015 6.13561 16.4397 4.5603C14.8644 2.985 12.7278 2.1 10.5 2.1C8.27218 2.1 6.13561 2.985 4.5603 4.5603C2.985 6.13561 2.1 8.27218 2.1 10.5C2.1 12.7278 2.985 14.8644 4.5603 16.4397C6.13561 18.015 8.27218 18.9 10.5 18.9V18.9ZM9.0531 6.73575L14.176 10.1503C14.2337 10.1887 14.2809 10.2407 14.3136 10.3017C14.3463 10.3627 14.3634 10.4308 14.3634 10.5C14.3634 10.5692 14.3463 10.6373 14.3136 10.6983C14.2809 10.7593 14.2337 10.8113 14.176 10.8496L9.05205 14.2642C8.98887 14.3061 8.91553 14.3301 8.83982 14.3337C8.7641 14.3373 8.68883 14.3203 8.62198 14.2846C8.55513 14.2488 8.4992 14.1957 8.46012 14.1307C8.42104 14.0658 8.40027 13.9915 8.4 13.9156V7.08435C8.40014 7.00838 8.42088 6.93388 8.46002 6.86877C8.49915 6.80365 8.55521 6.75038 8.62223 6.7146C8.68925 6.67883 8.76471 6.66191 8.84059 6.66563C8.91646 6.66936 8.98991 6.69359 9.0531 6.73575V6.73575Z"
        fill="var(--theme-secondary)"
      />
    </svg>
  );

  return (
    <section className="product-form-card flex flex-column gap-4">
      <FormSectionHeader
        icon={svgIcon}
        title={localeText("digitalProductFiles")}
        subtitle={localeText("digitalProductFilesSubtitle")}
      />
      <DigitalFileCard
        title={localeText("coverImage")}
        required
        help={localeText("coverImageHelp")}
        formats={localeText("coverImageFormats")}
        sizeLabel={localeText("coverImageSize")}
        file={cover}
        accept="image/jpeg,image/png,image/webp"
        maxBytes={COVER_MAX_BYTES}
        isImage
        onSelect={(files) => form.setImages(files.slice(0, 1))}
        onRemove={() => form.removeImage(0)}
        icon={svgIconImg}
      />
      <DigitalFileCard
        title={localeText("mainProductFile")}
        required
        help={localeText("mainProductFileHelp")}
        formats={localeText("mainProductFileFormats")}
        sizeLabel={localeText("mainProductFileSize")}
        file={form.downloadableFile}
        accept="*/*"
        maxBytes={DIGITAL_FILE_MAX_BYTES}
        onSelect={(files) => form.setDownloadableFile(files[0] || null)}
        onRemove={() => form.setDownloadableFile(null)}
        icon={svgIconFile}
      />
      <DigitalFileCard
        title={localeText("previewSample")}
        help={localeText("previewSampleHelp")}
        formats={localeText("previewSampleFormats")}
        sizeLabel={localeText("previewSampleSize")}
        file={form.downloadableSample}
        accept="*/*"
        maxBytes={DIGITAL_FILE_MAX_BYTES}
        onSelect={(files) => form.setDownloadableSample(files[0] || null)}
        onRemove={() => form.setDownloadableSample(null)}
        icon={svgIconSample}
      />
      <p className="product-form-help">{localeText("requiredFilesToPublish")}</p>
    </section>
  );
}

export default DigitalFilesSection;
